/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import React, { Component }                           from 'react';
import Helmet                                         from 'react-helmet';
import { DefaultPage }                                from '../templates/DefaultPage';
import { StyledContentWrapper }                       from '../atoms/StyledContentWrapper';
import { StyledContent }                              from '../atoms/StyledContent';
import { StyledVerticalFlow }                         from '../atoms/StyledVerticalFlow';
import { Heading1, Heading2, RegularText }            from '../atoms/StyledTypography';
import { ButtonAnchor }                               from '../molecules/ButtonAnchor';
import { RegularList }                                from '../molecules/RegularList';
import { ContentIcon }                                from '../molecules/ContentIcon';
import { IconPriceLightBulb }                         from '../atoms/IconPriceLightBulb';
import { Colours }                                    from '../../styles/variables';
import { StyledResponsiveFlexContainer }              from '../atoms/StyledResponsiveFlexContainer';
import { StyledResponsiveFlexContent }                from '../atoms/StyledResponsiveFlexContent';
import { StyledBigPrice }                             from '../atoms/StyledBigPrice';
import { StyledPricingPlan }                          from '../atoms/StyledPricingPlan';


/*********************************************************************************
 2. Component
 *********************************************************************************/

export class Pricing extends Component {
    constructor() {
        super();

        this.state = {
            includeInFreePlan: [
                { text: 'Unlimited postcode searches' },
                { text: 'Search filters' },
                { text: 'Historical transactions' },
                { text: 'Property location maps' },
                { text: 'Interactive charts' },
                { text: 'Sharing insights charts' }
            ],
            includeInProPlan: [
                { text: 'Everything in the Free plan' },
                { text: 'Property transactions comparison' },
                { text: 'Search history' },
                { text: 'Data exports' },
                { text: 'Custom PDF reports' }
            ]
        };
    }

    render() {
        return (
            <DefaultPage>
                <Helmet title="Pricing | Price Paid Data"/>
                <StyledContentWrapper>
                    <StyledContent>
                        <StyledVerticalFlow>
                            <Heading1>Pricing plans</Heading1>
                        </StyledVerticalFlow>
                        <StyledVerticalFlow>
                            <StyledResponsiveFlexContainer>
                                <StyledResponsiveFlexContent>
                                    <StyledVerticalFlow>
                                        <StyledPricingPlan>
                                            <Heading2>Free</Heading2>
                                            <StyledBigPrice>£0</StyledBigPrice>
                                            <RegularText>For users wanting a test drive and discover the
                                                potential opportunities and insights.</RegularText>
                                        </StyledPricingPlan>
                                    </StyledVerticalFlow>
                                    <StyledVerticalFlow>
                                        <ButtonAnchor to="/contact">Sign up for a free account</ButtonAnchor>
                                    </StyledVerticalFlow>
                                    <StyledVerticalFlow>
                                        <StyledVerticalFlow>
                                            <RegularText>The free plan includes:</RegularText>
                                        </StyledVerticalFlow>
                                        <StyledVerticalFlow>
                                            <RegularList items={this.state.includeInFreePlan}/>
                                        </StyledVerticalFlow>
                                    </StyledVerticalFlow>
                                </StyledResponsiveFlexContent>
                                <StyledResponsiveFlexContent>
                                    <StyledVerticalFlow>
                                        <StyledPricingPlan>
                                            <Heading2>PRO</Heading2>
                                            <StyledBigPrice>Coming soon</StyledBigPrice>
                                            <RegularText>For advanced users and industry experts that require up-to-date
                                                data.</RegularText>
                                        </StyledPricingPlan>
                                    </StyledVerticalFlow>
                                    <StyledVerticalFlow>
                                        <ButtonAnchor to="/contact" colour={Colours.Tundora}>Register your
                                            interest</ButtonAnchor>
                                    </StyledVerticalFlow>
                                    <StyledVerticalFlow>
                                        <StyledVerticalFlow>
                                            <RegularText>The PRO plan includes:</RegularText>
                                        </StyledVerticalFlow>
                                        <StyledVerticalFlow>
                                            <RegularList items={this.state.includeInProPlan}/>
                                        </StyledVerticalFlow>
                                    </StyledVerticalFlow>
                                </StyledResponsiveFlexContent>
                            </StyledResponsiveFlexContainer>
                        </StyledVerticalFlow>
                        <ContentIcon icon={<IconPriceLightBulb/>}/>
                    </StyledContent>
                </StyledContentWrapper>
            </DefaultPage>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/Pricing.js